<template>
  <div>
    <b> {{ modelValue.source.name }} {{ modelValue.source.location }}</b>
    <span>
      {{
        formatIntlDate(modelValue.start_time, {
          dateStyle: "short",
          timeStyle: "medium",
        })
      }}
      <small>({{ modelValue.source.time_zone }})</small>
    </span>
    <div class="textbox">
      <!-- eslint-disable vue/no-v-html -->
      <span
        contenteditable="true"
        @input="updateText"
        v-html="text"
      />
    </div>
  </div>
</template>

<script>
import { formatIntlDate } from "shared/helpers/date";
import { highlight } from "shared/helpers/string";

export default {
  name: "RadioClipTextEdit",
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    keywords: {
      type: Array,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      text: "",
    };
  },
  mounted() {
    this.text = this.highlightedText(this.modelValue.text);
  },
  methods: {
    formatIntlDate,
    highlightedText(text) {
      return highlight(this.stripEmTag(text), this.keywords);
    },
    stripEmTag(text) {
      return text.replace(/<\/?em>/g, "");
    },
    updateText(event) {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        text: event.target.innerHTML,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.textbox {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 25px;
}

span[contenteditable] {
  display: block;
  background-color: #c0c0c0;
  padding: 8px;
  min-height: 100px;

  :deep(em) {
    background-color: #fc0 !important;
    padding: 1px 2px !important;
    font-style: normal !important;
  }
}
</style>
